import { render, staticRenderFns } from "./EditUserData.vue?vue&type=template&id=2757ebd9"
import script from "./EditUserData.vue?vue&type=script&lang=js"
export * from "./EditUserData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports